import React, { createContext, useReducer, useEffect } from 'react';
import Loader from '../components/Loader/Loader';
import { useCookies } from 'react-cookie';
import { idb } from 'src/utils/idb';


const user = JSON.parse(localStorage.getItem('User'))

const initialState = {
  isLoggedIn: user ? true : false,
  isInitialised: true,
  user: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'logged_status': {
      const { isLoggedIn, user } = action.payload;

      return {
        ...state,
        isLoggedIn,
        isInitialised: true,
        user
      };
    }
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  logout: () => Promise.resolve(),
  login: () => Promise.resolve
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [cookies, setCookie, removeCookie] = useCookies();

  const removeLocalStorageValues = () => {
    if ('userAlreadyLogin' in localStorage) {
      var myItem = localStorage.getItem('userAlreadyLogin');
      const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));
      localStorage.clear();
      localStorage.setItem('userAlreadyLogin', myItem);
      if(selectedProfileId) {
        sessionStorage.setItem('selectedProfileId', selectedProfileId ? JSON.stringify(selectedProfileId) :{})
      }
    } else {
      const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));
      localStorage.clear()
      if(selectedProfileId) {
        sessionStorage.setItem('selectedProfileId', selectedProfileId ? JSON.stringify(selectedProfileId) :{})
      }
    }
    sessionStorage.removeItem('cacheTargetingSettings');
    localStorage.removeItem('brandConfigureIgnore');
    setTimeout(() => {
      removeCookie('last-profile')
      removeCookie('active_profiles')
      removeCookie('plan_info')
    }, 100);
  }

  const logout = async () => {
    // localStorage.removeItem('User')
    removeLocalStorageValues()

    // Clear IDB data
    idb.clearAllData();


    return dispatch({
      type: 'logged_status',
      payload: {
        isLoggedIn: false,
        user: {}
      }
    });

  };

  const login = () => {
    const user = localStorage.getItem('User')
    const userDetails = JSON.parse(user)
    if (userDetails && userDetails.token) {
      dispatch({
        type: 'logged_status',
        payload: {
          isLoggedIn: true,
          user: userDetails
        }
      })
    }
  };

  useEffect(() => {
    const user = localStorage.getItem('User')
    const userDetails = JSON.parse(user)
    if (userDetails && userDetails.token) {
      dispatch({
        type: 'logged_status',
        payload: {
          isLoggedIn: true,
          user: userDetails
        }
      })
    }
  }, []);

  if (!state.isInitialised) {
    return <Loader />;
  }

  return (
    <AuthContext.Provider value={{ ...state, logout, login }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
